export default __webpack_public_path__ + "static/media/012-ice cream.97ca0bfc.svg";